import { ICongelamentosPorDiaCompleto, IExtratoCongelamentos } from "../../../../pages/CongelamentoCNPJ/Congelamentos/Extrato/interfaces";
import { api } from "../../../apiAxios";
import { getToken } from "../../../LStorage/token";
import { urlHttpGov } from "../../../urls";

class ExtratoService {
    private readonly baseURL = `${urlHttpGov}/congelamento-cnpj/extrato`;

    async getResumo(signal?: AbortSignal): Promise<IExtratoCongelamentos> {

        const { data } = await api.get(`${this.baseURL}`, {
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
            signal
        });

        return data;
    }

    async getDetalhesDia(date: string, signal?: AbortSignal): Promise<ICongelamentosPorDiaCompleto> {

        const { data } = await api.get(`${this.baseURL}/dia?data=${date}`, {
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
            signal
        });

        return data;
    }

}

export default new ExtratoService();
